<template>
  <v-btn v-if="!selected"
         style="text-transform:none; font-weight: normal"
         color="transparent"
         rounded
         elevation="0"
         :class="{'disable-events': disabled}"
         @click="onClick"
  >
    <v-flex shrink>
      <strong>{{ formatDate(date) }}</strong>
      <br />
      {{ formatDay(date) }}
      <template v-if="events !== null">
        <v-icon v-for="color in events(date)" :key="color" :color="color" style="width: 12px; height: 12px">mdi-circle-medium</v-icon>
      </template>
    </v-flex>
  </v-btn>

  <v-menu v-else
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scroll-y-transition"
          style="z-index: 4001"
          offset-y
          nudge-left="95"
          top
          min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        style="text-transform:none; font-weight: normal"
        color="grey lighten-3"
        v-bind="attrs"
        v-on="on"
        rounded
        elevation="0"
      >
        <v-flex shrink>
          <strong>{{ formatDate(date) }}</strong>
          <br />
          {{ formatDay(date) }}
          <template v-if="events !== null">
            <v-icon v-for="color in events(date)" :key="color" :color="color" style="width: 12px; height: 12px">mdi-circle-medium</v-icon>
          </template>
        </v-flex>
      </v-btn>
    </template>
    <v-date-picker
      width="280"
      v-model="select"
      :max="getCurrenDateInMS()"
      scrollable
      @input="menu = false"
      :first-day-of-week="1"
      :events="events"
      :locale="getIsoLocale()"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import { DateTime } from "luxon";
import i18n from "@/plugins/i18n";

export default {
  name: "DateChip",
  props: {
    date: {
      type: String,
      mandatory: true
    },
    events: {
      type: Function,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: false,
      select: null,
      selectEvent: true
    };
  },

  methods: {
    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    formatDate(value) {
      return DateTime.fromISO(value).toFormat("d.M.");
    },

    formatDay(value) {
      return DateTime.fromISO(value).toFormat("ccc");
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").toISO();
    },

    getEvents(date) {
      const result = this.events(date);

      if (result == null || !result)
        return [];
      else
        return result;
    },

    onClick() {
      this.$emit("date-click", this.date);
    }
  },

  watch: {
    select: function() {
      if (this.selectEvent)
        this.$emit("select", this.select);
      else
        this.selectEvent = true;
    },

    date: function() {
      this.selectEvent = false;
      this.select = this.date;
    }
  },

  mounted() {
    this.selectEvent = false;
    this.select = this.date;
  }
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
  color: #adadad;
}
</style>